export default {
  messageInputPlaceholder: 'Send message',
  sendAMessage: 'Send A Message',
  noMessages: 'No news at the moment',
  conversationNotFound: 'Conversation not found',
  initFailed: 'Failed to initialize conversation',
  cannotGetReceiverInfo: 'Cannot get receiver information',
  sendFailed: 'Failed to send message',
  newMessages: '{count} new message(s)',
  error: {
    messageSaveFailed: 'Failed to save message',
    messageHandleFailed: 'Failed to process message',
  },
  message: {
    unsupported: '[This message type is not yet supported]',
  },
}
